module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/box-a428eed06ea58dca24f1294eae572f45.svg";